var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnHold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.834,
    height: 14.837,
    viewBox: "0 0 14.834 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49369",
    "data-name": "Group 49369",
    transform: "translate(-2206.717 9875.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93663",
    "data-name": "Path 93663",
    d: "M19.69,13.255a6.649,6.649,0,1,0,2.6.525A6.614,6.614,0,0,0,19.69,13.255Z",
    transform: "translate(2194.444 -9887.592)",
    fill: "none",
    stroke: "#ef8a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_599",
    "data-name": "Line 599",
    y2: 4.465,
    transform: "translate(2212.662 -9869.691)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_600",
    "data-name": "Line 600",
    y2: 4.465,
    transform: "translate(2216.102 -9869.691)",
    fill: "none",
    stroke: "#ef8a50",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHold);
export default __webpack_public_path__ + "static/media/on-hold.f85135832971fa8e30527d1de105c6d6.svg";
export { ForwardRef as ReactComponent };